module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/weight.svg?f8806bb26dc8920b56037f28f093fd63";